import { Injectable, inject } from "@angular/core";
import { StorageService, StorageKeys } from "@magpie/services";

@Injectable({
	providedIn: "root",
})
export class ThemeService {
	private storageService = inject(StorageService);

	constructor() {
		this.initializeTheme();
	}

	private async initializeTheme(): Promise<void> {
		const theme = await this.storageService.get<string>(
			StorageKeys.ThemePreference,
		);
		if (theme === "dark") {
			document.documentElement.classList.add("p-dark");
		}
	}

	toggleTheme(): void {
		const isDark = document.documentElement.classList.toggle("p-dark");
		void this.storageService.set(
			StorageKeys.ThemePreference,
			isDark ? "dark" : "light",
		);
	}
}
